<template>
  <div class="col-12">

          <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="tab_empty">
            <div class="row">
              <div class="col-7">
                <div class="row mb-3" style="font-size:13px;">
                  <div class="col"><a class="text-dark" @click="backToPathway()" style="cursor: pointer;"><i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                      Back to pathways</a></div>
                  <div class="col">{{ this.pathwayName }}</div>
                  <div class="col text-right">
                    <button class="btn btn-red btn-md input-height-15 rounded" style="font-size: 13px; padding: 3px 15px;border-radius: 8px !important; margin-top: -5px;" @click="onSubmit()">Save Pathway</button></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div v-for="(step, index) in pathway_step_obj.steps">
                    <div class="pathways_step rounded shadow mb-3 ">
                      <div class="bg-white pathways_step_title border-bottom"  style="border-top-left-radius: 15px !important; border-top-right-radius: 15px !important;"  @click="borderClick(index, 'NULL')" :class="((stepBorderIndex == parseInt(index+1) && objectiveBorderIndex == 'NULL')) ? 'border-class' : ''">
                        <div class="row">
                          <div class="col-3">
                            <div class="px-3 py-2">Step {{ parseInt(index + 1) }} - </div>
                          </div>
                          <div class="col-5 font-weight-bold text-center">
                            <div class="px-3 py-2" v-if="step.stepTitle != ''">{{ step.stepTitle }} <i class="ml-1 fa fa-pencil text-primary" aria-hidden="true" @click="editStepDetails(index)" style="cursor: pointer; color: #00ACEE !important;"></i> 
                            <i class="ml-1 fa fa-close text-primary" aria-hidden="true" @click="deleteStepConfirm(index)" style="cursor: pointer; color: #002F42 !important;"></i> 
                            </div>

                            <div class="px-3 py-2" v-else>Name of step <i class="ml-1 fa fa-pencil text-primary" aria-hidden="true" @click="editStepDetails(index)" style="cursor: pointer; color: #00ACEE !important;"></i><i class="ml-1 fa fa-close text-primary" aria-hidden="true" @click="deleteStepConfirm(index)" style="cursor: pointer; color: #002F42 !important;"></i> </div>
                          </div>
                          <div class="col-4 text-right">
                            <div class="px-3 py-2">Objectives - {{ step.objective.length }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Pathway Objective -->
                      <div v-for="(objective, oindex) in step.objective">
                      <div class="pathways_step_item border-bottom bg-white" style="" :class="((stepBorderIndex == parseInt(index+1) && objectiveBorderIndex == parseInt(oindex+1))) ? 'border-class' : ''" @click="borderClick(index, oindex)">
                        <div class="row">
                          <div class="col-2">
                            <div class="pl-3 py-2 text-right">

                              <h5 class="mb-0" v-if="objective.objectiveType == 'Assessment'">
                                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'External Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>


                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Task List'">
                                <i class="fa fa-list-ul" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Form'">
                                <i class="fa fa-file-text" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Certificate'">
                                <i class="fa fa-certificate" aria-hidden="true"></i>
                              </h5>

                            </div>
                          </div>
                          <div class="col-8">
                            <div class="pl-3 py-2">{{ objective.objectiveName }}</div>
                          </div>
                          <div class="col-2 text-center">
                            <button type="button" class="close" aria-label="Close" style="float: none; margin-top: 7px;" @click="deleteObjectiveConfirm(index, oindex)">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      </div>
                      <!-- End Pathway Objective -->

                      <div class="pathways_step_item border-bottom bg-white" @click="borderClick(index, 'NEW')" :class="((stepBorderIndex == parseInt(index+1) && objectiveBorderIndex == 'NEW')) ? 'border-class' : ''">
                        <div class="row">
                          <div class="col-12">
                            <div class="pl-3 py-2 text-center" style="cursor: pointer;"><a style="color: #00ACEE;" @click="addNewObjective(index)">Add an Objective</a></div>
                          </div>
                        </div>
                      </div>

                    </div>
                    </div>

                    <div class="text-center mb-5">
                      <button class="btn btn-red btn-md input-height-15 rounded" style="font-size: 13px; padding: 3px 15px;border-radius: 8px !important; margin-top: -5px;" @click="addMoreSteps()">Add Step</button>
                    </div>



                  </div>
                </div>

              </div>
              <div class="col-5" style="font-size: 13px;" v-if="addStepModalVisible == true">
                <div class="card bg-white" style="margin-top:-9px;border-radius: 0;padding: 15px 0 50px 0;">
                  <div class="card-body px-3">
                    <h6 class="card-title float-left">Step {{ parseInt(stepIndex + 1) }}</h6>
                    <button type="button" class="close float-right" aria-label="Close" @click="closeStepModal">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="clearfix"></div>

                      <div class="form-group">
                        <label for="pathway_step_name">Name <span class="required">*</span></label>
                        <input v-model="stepTitle"
                              name="stepTitle"
                              placeholder="Name the step"
                              class="col-lg-12 input-text form-control"
                              style="line-height: 30px; "
                              v-validate="'required'"
                              maxlength="140" />
                        <div v-if="verrors.firstByRule('stepTitle', 'required')" class="margin-bottom-5 validate-warning-msg">Step Name is required</div>
                      </div>
                      <div class="form-group">
                        <label for="pathway_step_description">Description</label>
                        <textarea
                          name="stepDescription" 
                          v-model="stepDescription"
                          placeholder="Add a description on what the level will focus on"
                          class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25 form-control"
                          maxlength="500" style="resize: none; height: 80px;line-height: 20px;">
                          </textarea>
                      </div>
                      <div class="text-center">
                        <button class="btn btn-red btn-md input-height-15 rounded" style="font-size: 13px; padding: 3px 15px;border-radius: 8px !important; margin-top: -5px;" @click="onCreateStep()">Save</button>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-5" style="font-size: 13px;" v-if="addObjectiveModalVisible == true">

                <div class="card bg-white pathway_objectives_box" style="margin-top:-9px;border-radius: 0;padding: 15px 0 50px 0;">
                  <div class="card-body px-3">
                    <h6 class="card-title float-left">Choose an Objective</h6>
                    <button type="button" class="close float-right" aria-label="Close" @click="closeObjectiveModal()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="clearfix"></div>

                    <div class="d-flex flex-wrap justify-content-around nav nav-tabs border-0">
                      <div class="border border-dark rounded text-center p-1 nav-item" :class="objectiveType == 'Assessment' ? 'pathway_objective_focus' : ''" data-toggle="tab" data-target="#objective_assessments" @click="getObjectiveOptions('Assessment')">
                        <i class="fa fa-check-circle-o h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Assessment</p>
                      </div>
                      <div class="border border-dark rounded text-center p-1 nav-item" :class="objectiveType == 'Course' ? 'pathway_objective_focus' : ''" data-toggle="tab" data-target="#objective_courses" @click="getObjectiveOptions('Course')">
                        <i class="fa fa-wrench h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Course</p>
                      </div>
                      <div class="border border-dark rounded text-center p-1 nav-item" :class="objectiveType == 'Task List' ? 'pathway_objective_focus' : ''" data-toggle="tab" data-target="#objective_tasklists" @click="getObjectiveOptions('Task List')">
                        <i class="fa fa-list-ul h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Task List</p>
                      </div>
                      <div class="border border-dark rounded text-center p-1 nav-item" data-toggle="tab" data-target="#objective_certificates" @click="getObjectiveOptions('Certificate')">
                        <i class="fa fa-certificate h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Certification</p>
                      </div>
                      <div class="border border-dark rounded text-center p-1 nav-item" data-toggle="tab" data-target="#objective_forms" @click="getObjectiveOptions('Form')">
                        <i class="fa fa-file-text h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Form</p>
                      </div>
                      <div class="border border-dark rounded text-center p-1 nav-item" data-toggle="tab" data-target="#objective_rewards">
                        <i class="fa fa-star-o h5" aria-hidden="true" style="font-size: 22px; margin-top: 5px; margin-bottom: 0;"></i>
                        <p class="mb-0">Reward</p>
                      </div>
                    </div>






                    <div class="tab-content">
                        <p class="font-weight-bold mb-1" v-if="objectiveType == 'Certificate'">Certifications</p>
                        <p class="font-weight-bold mb-1" v-else-if="objectiveType == 'External Course'">Course</p>
                        <p class="font-weight-bold mb-1" v-else>{{ objectiveType }}</p>
                        <div v-show="objectiveLoading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                        <div class="custom-control custom-radio ml-3" v-for="(option, index) in objectiveOptions" style="padding-top: 2px; margin-top: 4px;">
                          <input :value="option.id" type="radio" name="objectiveId" :id="option.id"
                          class="custom-control-input"
                          v-model="objectiveId" @click="addObjective(option.id, option.text, $event)" style="margin-top: -2px;">
                          <label class="custom-control-label" :for="option.id">{{ option.text }}</label>
                        </div>


                        
                     


                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>   

        <DeleteModal :isModalVisible="isDeleteModalVisible"  @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAction()">Confirm</button>
          </div>
        </DeleteModal>



  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import DeleteModal from '../shared/delete_modal_alert.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'pathwayId'],
      data() {
        return {
          pathway_step_obj: {
            pathway: [],
            steps: [],
            removed_objective: [],
            removed_step: [],
          },
          pathwayName: '',
          addStepModalVisible: false,
          addObjectiveModalVisible: false,
          stepTitle: '',
          stepDescription: '',
          stepIndex: '',
          objectiveIndex: '',
          objectiveType: '',
          objectiveId: '',
          objectiveLoading: false,
          objectiveOptions: [],
          stepBorderIndex: '',
          objectiveBorderIndex: '',
          isDeleteModalVisible: false,
          deleteList: '',
          deleteMessage: '',
          loading: false,
        }
      },

      components: {
        DeleteModal,
      },
      methods: {
        deleteStepConfirm: function(stepIndex) {
          this.deleteMessage = 'Are you sure you want to delete? This will delete the step and the related objective.';
          this.stepIndex = stepIndex;
          this.deleteList = 'Step';
          this.isDeleteModalVisible = true;
        },
        deleteObjectiveConfirm: function(stepIndex, objectiveIndex) {
          this.deleteMessage = 'Are you sure you want to delete? This will delete the objective.';
          this.stepIndex = stepIndex;
          this.objectiveIndex = objectiveIndex;
          this.deleteList = 'Objective';
          this.isDeleteModalVisible = true;
        },
        deleteAction: function() {
          if(this.deleteList == 'Objective') {
            this.removeObjective(this.stepIndex, this.objectiveIndex);
          }
          else {
            this.removeStep(this.stepIndex);
          }
        },
        backToPathway() {
          this.$parent.selectedComponent = 'PathwaysTab';
        },
        borderClick(stepIndex, objectiveIndex) {
          this.stepBorderIndex = parseInt(stepIndex+1);
          if((objectiveIndex != 'NULL') && (objectiveIndex != 'NEW')) {
            this.objectiveBorderIndex = parseInt(objectiveIndex+1);
          }
          else {
            this.objectiveBorderIndex = objectiveIndex;
          }
        },
        removeStep(stepIndex) {
          if(this.pathway_step_obj.steps[stepIndex].update == true) {
            this.pathway_step_obj.removed_step.push({
              step_id: this.pathway_step_obj.steps[stepIndex].id,
            });
          }
          this.pathway_step_obj.steps.splice(stepIndex, 1);
          this.$store.dispatch('pathway_steps', this.pathway_step_obj);
        },
        removeObjective(stepIndex, objectiveIndex) {
          if(this.pathway_step_obj.steps[stepIndex].objective[objectiveIndex].update == true) {
            this.pathway_step_obj.removed_objective.push({
              objective_id: this.pathway_step_obj.steps[stepIndex].objective[objectiveIndex].id,
            });
          }
          this.pathway_step_obj.steps[stepIndex].objective.splice(objectiveIndex, 1);
          this.$store.dispatch('pathway_steps', this.pathway_step_obj);
        },
        doValidate(id, type) {
          var flag = 0;
          if((type == 'Assessment') || (type == 'Course')) {
            for(var x=0; x < this.pathway_step_obj.steps[this.stepIndex].objective.length; x++) {
              if((id == this.pathway_step_obj.steps[this.stepIndex].objective[x].objectiveId) && (this.pathway_step_obj.steps[this.stepIndex].objective[x].objectiveType == type)) {
                if(type == 'External Course') {
                  type = 'Course';
                }
                flag = 1;
                alert("This "+type+" is already exists in this step");
              }
            }
          }
          else {
            for(var i=0; i < this.pathway_step_obj.steps.length; i++) {
              for(var x=0; x < this.pathway_step_obj.steps[i].objective.length; x++) {
                if((id == this.pathway_step_obj.steps[i].objective[x].objectiveId) && (this.pathway_step_obj.steps[i].objective[x].objectiveType == type)) {
                  flag = 1;
                  alert("This "+type+" is already exists in this pathway");
                }
              }
            }
          }
          return flag;
        },
        addObjective(id, text, event) {
          if(event.target.checked == true) {
            /* Check option already exists */
            if(this.objectiveType == 'Course' || this.objectiveType == 'External Course') {
              var idd = id.split('-');
              if(idd[0] == 'E') {
                id = idd[1];
                this.objectiveType = 'External Course'
              }
              else {
                id = idd[1];
                this.objectiveType = 'Course'
              }
            }

            var flag = this.doValidate(id, this.objectiveType);
            if(flag == 0) {
              this.pathway_step_obj.steps[this.stepIndex].objective.push({
                'id': '',
                'objectiveType': this.objectiveType,
                'objectiveId': id,
                'objectiveName': text,
                'edit': false,
                'update': false,
                'modified': false,
              });
              this.$store.dispatch('pathway_steps', this.pathway_step_obj);
            }
          }
        },
        closeObjectiveModal() {
          this.stepTitle = '';
          this.objectiveOptions = [];
          this.objectiveId = '';
          this.objectiveType = '';
          this.stepIndex = '';
          this.addObjectiveModalVisible = false;
        },
        addNewObjective(stepIndex) {
          this.stepIndex = stepIndex;
          this.objectiveOptions = [];
          this.objectiveId = '';
          this.objectiveType = '';
          this.addObjectiveModalVisible = true;
        },
        getObjectiveOptions(type) {
          this.objectiveLoading = true;
          this.objectiveType = type;
          this.objectiveOptions = [];
          if(this.objectiveType == 'Assessment') {
            axios.get('/account-lookup/assessment-lists', {
              params: {
                user_roles: 'ROLE_MENTEE',
                account_id: this.accountId
              },
            })
            .then(response =>  {
              for(var i=0; i < response.data.length; i++) {
                var group = {id: response.data[i].value, text: response.data[i].name};
                this.objectiveOptions.push(group);
              }
              this.objectiveLoading = false;
            })
            .catch(function(error) {
              console.log(error);
            });

          } else if(this.objectiveType == 'Course') {
            axios.get('/pathway/course-lists', {
              params: {
                user_roles: 'ROLE_MENTEE',
                account_id: this.accountId
              },
            })
            .then(response =>  {
              for(var i=0; i < response.data.length; i++) {
                var group = {id: response.data[i].value, text: response.data[i].name};
                this.objectiveOptions.push(group);
              }
              this.objectiveLoading = false;
            })
            .catch(function(error) {
              console.log(error);
            });
          } else if(this.objectiveType == 'Task List') {
            axios('/alltasklists-account',
              {
                method: 'GET',
                params: {
                  account_id: this.accountId,
                }
              },
            )
            .then(response => {
                for(var i=0; i < response.data.length; i++) {
                  var tasklistItem = {id: response.data[i].id, text: response.data[i].name};
                  this.objectiveOptions.push(tasklistItem);
                }
                this.objectiveLoading = false;
             })
            .catch(error => {

            });
          } else if(this.objectiveType == 'Form') {
            axios('/pathway/form-lists',
              {
                method: 'GET',
                params: {
                  user_roles: 'ROLE_MENTEE',
                  account_id: this.accountId,
                }
              },
            )
            .then((resp) => {
                for(var i=0; i < resp.data.data.length; i++) {
                  var tasklistItem = {id: resp.data.data[i].id, text: resp.data.data[i].name};
                  this.objectiveOptions.push(tasklistItem);
                }
                this.objectiveLoading = false;
            })
            .catch(error => {

            });

          } else if(this.objectiveType == 'Certificate') {
            axios.get('/pathway/certification-lists', {
              params: {
                account_id: this.accountId
              },
            })
            .then(response =>  {
              for(var i=0; i < response.data.length; i++) {
                var group = {id: response.data[i].id, text: response.data[i].text};
                this.objectiveOptions.push(group);
              }
              this.objectiveLoading = false;
            })
            .catch(function(error) {
              console.log(error);
            });

          }

        },
        addMoreSteps() {
          this.pathway_step_obj.steps.push({
            id: '',
            stepTitle: '',
            stepDescription: '',
            objective: [],
            edit: false,
            update: false,
            modified: false,
          });
          this.$store.dispatch('pathway_steps', this.pathway_step_obj);
        },
        closeStepModal() {
          this.stepTitle = '';
          this.stepDescription = '';
          this.stepIndex = '';
          this.addStepModalVisible = false;
        },
        doValidateStepTitle() {
          var flag = 0;
          for(var i=0; i < this.pathway_step_obj.steps.length; i++) {
            if(this.pathway_step_obj.steps[i].stepTitle == '') {
              flag = 1;
              alert("Please add step title for step - " + parseInt(i+1));
            }
          }
          return flag;
        },
        onSubmit() {
          var flag = this.doValidateStepTitle();
          if(flag == 0) {
            axios('/post-pathway-step-details',
               {
                 method: 'POST',
                 data:
                  {
                    pathway_step_obj: this.pathway_step_obj,
                  },
               }
             )
            .then((resp) => {
                //this.getPathwayStepDetails();
                this.$parent.selectedComponent = 'PathwaysTab';
             })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          }

        },
        onCreateStep() {
          this.$validator.validateAll().then((result) => {
          if ((this.verrors.items.length === 0)) {
            this.pathway_step_obj.steps[this.stepIndex].stepTitle = this.stepTitle;
            this.pathway_step_obj.steps[this.stepIndex].stepDescription = this.stepDescription;
            if(this.pathway_step_obj.steps[this.stepIndex].update == true) {
              this.pathway_step_obj.steps[this.stepIndex].modified = true;
            }
            this.stepTitle = '';
            this.stepDescription = '';
            this.stepIndex = '';
            this.addStepModalVisible = false;
            this.$store.dispatch('pathway_steps', this.pathway_step_obj);
          }
          });
          return false;
        },
        editStepDetails(index) {
          this.stepIndex = index;
          this.stepTitle = this.pathway_step_obj.steps[index].stepTitle;
          this.stepDescription = this.pathway_step_obj.steps[index].stepDescription;
          this.addStepModalVisible = true;
        },
        getPathwayStepDetails: function() {
          axios.get('/get-pathway-step-details', {
            params: {
              pathwayId: this.pathwayId,
            }
          })
          .then((resp) => {
              this.pathway_step_obj.pathway = resp.data.pathway;
              this.pathwayName = this.pathway_step_obj.pathway.name;
              this.pathway_step_obj.steps = resp.data.pathwayStep;
              if(this.pathway_step_obj.steps.length == 0) {
                this.pathway_step_obj.steps.push({
                  id: '',
                  stepTitle: '',
                  stepDescription: '',
                  objective: [],
                  edit: false,
                  update: false,
                  modified: false,
                });
              }
              this.$store.dispatch('pathway_steps', this.pathway_step_obj);
           })
          .catch(error => {
            if(error.response.data.message == 'Access denied.') {
              router.push("/forbidden");
            }
          });

        },
      },
      created() {
        if(this.$store.state.pathway_steps) {
          this.pathway_step_obj.pathway = this.$store.state.pathway_steps.pathway;
          this.pathwayName = this.pathway_step_obj.pathway.name;
          this.pathway_step_obj.steps = this.$store.state.pathway_steps.steps;
          this.pathway_step_obj.removed_objective = this.$store.state.pathway_steps.removed_objective;
        }
        else {
          this.getPathwayStepDetails();
        }
        
      },

}

</script>

<style scoped>
.fa-pencil {
  cursor: pointer;
}
.pathway_objectives_box .d-flex div {
  width: 85px;
  margin-bottom: 15px;
  cursor: pointer;
}
@media(min-width:1400px) {
  .pathway_objectives_box .d-flex div {
    width: 115px;
    margin-bottom: 15px;
    cursor: pointer;
  }
}
.pathway_objective_focus {
  color: #00ACEE !important;
  background-color: #f0f9fc !important;
  border-color: #6cc2e2 !important;
  border: 1px solid #6cc2e2 !important;
}
.custom-control-label {
  font-size: 14px;
  margin-top: 3px;

}
.custom-radio .custom-control-label::before {
  top: 3px;
}
.border-class {
  background-color: #f0f9fc !important;
  border: 1px solid #6cc2e2 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_pathway_step.vue